var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{'green--text': _vm.isGoUp, 'red--text': !_vm.isGoUp }},[_vm._v(_vm._s(_vm._f("NumFormat")(_vm.currentPrice)))])}
var staticRenderFns = []

export { render, staticRenderFns }